<template>
  <div
    id="app"
    v-loading.fullscreen.lock="$store.state.global.loading"
  >
    <s-header />
    <s-main>
      <el-card v-if="alert.show">
        <el-alert
          :closable="false"
          show-icon
          :title="alert.title"
          :type="alert.type"
        />
      </el-card>
      <router-view />
    </s-main>
    <s-footer />
  </div>
</template>

<script>
import SFooter from '@/components/singletons/SFooter'
import SHeader from '@/components/singletons/SHeader'
import SMain from '@/components/singletons/SMain'

export default {
  name: 'App',

  metaInfo: {
    title: 'Coaching für Schulleitungen',
    titleTemplate: '%s | LI Hamburg Coaching'
  },

  components: {
    SFooter,
    SHeader,
    SMain
  },

  computed: {
    alert () {
      return this.$store.state.global.alert
    }
  }
}
</script>
